// @ts-nocheck
import { Button, TextField } from "@material-ui/core";
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import * as React from "react";
import { useForm } from "react-hook-form";
type NetworkState = "PENDING" | "SUCCEED" | "FAILED" | "IDLE";

// utils/validators.js
export const validateIranMobile = (value: string): boolean | string => {
  const regex = /^09\d{9}$/;
  if (value) {
    if (!regex.test(value)) {
      return "شماره موبایل صحیح نمیباشد";
    }
    return true;
  }
};

interface IFormInput {
  sellerMobile: string;
  transactionDate: string;
  transactionId: string;
  transactionPrice: number;
  bankAccountFrom: string;
  bankAccountTo: string;
}

export function SubmitTransaction() {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<IFormInput>({
    mode: "onChange",
    defaultValues: {
      sellerMobile: null,
      transactionDate: null,
      transactionId: null,
      transactionPrice: null,
      bankAccountFrom: null,
      bankAccountTo: null,
    },
  });

  const [errorMessages, setErrorMessages] = React.useState([]);
  const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");

  const ERROR_MESSAGES_TRANSLATE = {
    "user-with-this-mobile-not-found": "فروشنده ای با این شماره یافت نشد!",
  };

  const onSubmit = async (data: IFormInput) => {
    setErrorMessages([]);
    let token: any = localStorage.getItem("credentials");
    const url = `${process.env.REACT_APP_LEMONADE_SERVER}/api/seller-payment-transactions`;
    const postData = {
      amount: data.transactionPrice,
      currency: "IRT",
      destinationAccountNumber: data.bankAccountTo,
      sellerMobile: data.sellerMobile,
      sourceAccountNumber: data.bankAccountFrom,
      receivedAt: data.transactionDate,
      transactionId: data.transactionId,
    };

    try {
      setNetworkState("PENDING");
      const { data } = await axiosWithAuthInterceptor({
        url: url,
        data: postData,
        method: "POST",
      });

      if (data.err) {
        throw data;
      }
      setNetworkState("SUCCEED");
    } catch (error) {
      if (error.err) {
        setErrorMessages([...error.err.details.messages]);
      }
      setNetworkState("FAILED");
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = () => {
    // Handle the upload logic using 'selectedFile'
    if (selectedFile) {
      console.log("File selected:", selectedFile);
      // Implement your upload logic here
    }
  };

  return (
    <>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("sellerMobile", {
            required: "شماره موبایل فروشنده را وارد نمایید",
            
          })}
          error={!!errors.sellerMobile}
          helperText={errors.sellerMobile ? errors.sellerMobile.message : null}
          fullWidth
          label="شماره موبایل فروشنده"
          variant="outlined"
        />

        <TextField
          {...register("transactionDate", {
            required: true,
          })}
          type="date"
          fullWidth
          error={!!errors.transactionDate}
          helperText={
            errors.transactionDate ? errors.transactionDate.message : null
          }
          label="تاریخ واریز"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />

        {/* <TextField
          label="عکس فیش"
          variant="outlined"
          fullWidth
          type="file"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            inputProps: {
              accept: "image/*", // Specify accepted file types
              onChange: handleFileChange,
            },
          }}
        /> */}

        <TextField
          {...register("transactionId")}
          fullWidth
          error={!!errors.transactionId}
          helperText={
            errors.transactionId ? errors.transactionId.message : null
          }
          label="شناسه واریز بانک"
          variant="outlined"
        />

        <TextField
          {...register("transactionPrice", {
            required: "مبلغ واریز را وارد نمایید",
            valueAsNumber: true,
          })}
          error={!!errors.transactionPrice}
          helperText={
            errors.transactionPrice ? errors.transactionPrice.message : null
          }
          fullWidth
          label="مبلغ واریز"
          variant="outlined"
        />
        <TextField
          {...register("bankAccountFrom")}
          error={!!errors.bankAccountFrom}
          helperText={
            errors.bankAccountFrom ? errors.bankAccountFrom.message : null
          }
          fullWidth
          label="شماره حساب مبدا"
          variant="outlined"
        />
        <TextField
          {...register("bankAccountTo")}
          error={!!errors.bankAccountTo}
          helperText={
            errors.bankAccountTo ? errors.bankAccountTo.message : null
          }
          fullWidth
          label="شماره حساب مقصد"
          variant="outlined"
        />

        <TextField
          label="توضیحات"
          variant="outlined"
          fullWidth
          multiline
          minRows={4}
        />

        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
          ثبت
        </Button>

        {networkState === "SUCCEED" && <p>اطلاعات شما با موفقیت ثبت شد</p>}
        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ? (
            errorMessages.map((message) =>
              ERROR_MESSAGES_TRANSLATE[message] ? (
                <p>{ERROR_MESSAGES_TRANSLATE[message]}</p>
              ) : (
                <p>خطایی رخ داده لطفا مجددا تلاش نمایید</p>
              )
            )
          ) : (
            <p>خطایی رخ داده لطفا مجددا تلاش نمایید</p>
          ))}
      </form>
    </>
  );
}
